import AutomationPage from './AutomationPage';

export default AutomationPage;
